import { dbg, sprintf } from './qb';

export class TraceBuffer {
  readonly MAX_LINES = 200;
  lines: string[] = [];
  /** @constructor */
  constructor() {}

  toString(): string {
    return this.lines.join('');
  }

  printf(...args: any[]) {
    //var args = [];
    //for (var i = 0; i < arguments.length; i++) {
    //    args.push(arguments[i]);
    //}
    const str = sprintf(args);
    this.lines.push(str);
    if (this.lines.length > this.MAX_LINES) {
      this.lines.shift();
    }
    dbg.print(str);
  }
}
